import { render, staticRenderFns } from "./SupervisionView.vue?vue&type=template&id=31f8aff6&scoped=true"
import script from "./SupervisionView.vue?vue&type=script&lang=js"
export * from "./SupervisionView.vue?vue&type=script&lang=js"
import style0 from "./SupervisionView.vue?vue&type=style&index=0&id=31f8aff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8aff6",
  null
  
)

export default component.exports